import { render, staticRenderFns } from "./test-showdown.vue?vue&type=template&id=23f319e6&scoped=true&"
import script from "./test-showdown.vue?vue&type=script&lang=js&"
export * from "./test-showdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f319e6",
  null
  
)

export default component.exports